import { render, staticRenderFns } from "./subPageFive.vue?vue&type=template&id=7fba1ef4&scoped=true"
var script = {}
import style0 from "./subPageFive.vue?vue&type=style&index=0&id=7fba1ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fba1ef4",
  null
  
)

export default component.exports